<template>

  <div class="app-container" >
    <van-nav-bar
      :title="$t('menu.site')"
      @click-left="$router.go(-1)"
      left-arrow
      fixed
      placeholder
    >
    </van-nav-bar>
    <div style="height:100%;width:100%;position:absolute;">
      <google-maps2 ref="googleMaps_look_ref" :allSiteLocation="allSiteLocation"></google-maps2>
    </div>

  </div>
</template>

<script>
  import GoogleMaps2 from '@/components/GoogleMaps2';
  import { getListAllRecoverySite } from "@/api";
  export default {
    name: "RecoverySite",
    components: {
      GoogleMaps2,
    },
    dicts: ['ls_status'],
    data() {
      return {
        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        // 显示搜索条件
        showSearch: true,
        // 总条数
        total: 0,
        // 回收站点表格数据
        recoverySiteList: [],
        // 弹出层标题
        title: "",
        // 是否显示弹出层
        open: false,
        // 是否显示设置定位弹出层
        openSiteLocation: false,
        // 是否显示查看定位弹出层
        lookSiteLocation: false,
        curZoomLevelOfMap: null, // 当前地图缩放等级
        latitudeStr: 51.50663,
        longitudeStr: -0.07326,
        siteStr: null,
        mapParams: {
          longitude: null, // 地图定位用的经度(监听变化)
          latitude: null // 地图定位用的纬度(监听变化)
        },
        allSiteLocation: null,
      };
    },
    created() {

      this.handleLookSites();
    },
    methods: {
      /** 当改变 地图搜索关键字 时 */
      whenChangeParams4Locate() {
        this.mapParams.latitude = this.form.latitude;
        this.mapParams.longitude = this.form.longitude;
      },
      // 打开站点管理员列表
      openSiteManagerDialog() {
        this.$refs.site_manager_ref.openSiteManagerDialog();
      },
      // 选中一个站点管理员
      siteManagerRowChange(val) {
        this.$set(this.form, 'siteManagerId', val.id);
        this.$set(this.form, 'siteManagerName', val.name);
        // 再校验一次，校验成功，清除校验信息
        this.$refs.form.validateField('siteManagerName');
      },
      // 打开站点设备列表
      openSiteEquipmentDialog() {
        this.$refs.site_equipment_ref.openSiteEquipmentDialog();
      },
      // 选中一个站点设备
      siteEquipmentRowChange(val) {
        this.$set(this.form, 'siteEquipmentId', val.id);
        this.$set(this.form, 'siteEquipmentNumber', val.number);
        // 再校验一次，校验成功，清除校验信息
        this.$refs.form.validateField('siteEquipmentNumber');
      },
      /** 当地图中心点改变时 */
      whenChangeCenterOfMap(
        {
          zoom,
          coordinateSystem,
          longitude,
          latitude,
          addressInfo
        }
      ) {
        this.curZoomLevelOfMap = zoom;
        // console.log("curZoomLevelOfMap==========" + this.curZoomLevelOfMap);
        let geographicInfo = {};
        // console.log(longitude, latitude);
        this.form['latitude'] = latitude;
        this.form['longitude'] = longitude;
        geographicInfo[coordinateSystem] = {'longitude': longitude, 'latitude': latitude};
        // console.log("JSON.stringify(geographicInfo)", JSON.stringify(geographicInfo));
        this.form['geographicInfo'] = JSON.stringify(geographicInfo);
        // this.form['addressLocation'] = addressInfo.formattedAddress;
        this.form['addressLocation'] = addressInfo;
      },
      /** 查看站点定位按钮操作 */
      handleLookSites() {
        let t = {
          "curZoomLever": 1,
          "language": 1,
          "latitude": "51.50663",
          "longitude": "-0.07326",
          "pageNum": 1,
          "pageSize": 10000,
          "type": 8
        };
        getListAllRecoverySite(t).then(response => {
          // console.log("response===",response)
          this.allSiteLocation = response.data;
          this.lookSiteLocation = true;
          // console.log("this.allSiteLocation===", this.allSiteLocation)
          // console.log("this.$refs.googleMaps_look_ref===", this.$refs.googleMaps_look_ref)
          if (this.$refs.googleMaps_look_ref != undefined) {
            this.$refs.googleMaps_look_ref.lookAllSiteLocation(response.data);
          }
        });
      },
    }
  };
</script>
